export default "__VITE_ASSET__WTsv9Pim__"